import { drawRect } from "./drawRect";

const drawInteraction = (container, data, onDrag) => {
  const bindingData = data
    ? [data]
    : container.datum()
      ? [container.datum()]
      : [];
  drawRect(container, data, onDrag);

  const hatchLines = [
    {
      class: "hatch1",
      x1: 0,
      y1: (d) => d.size.height,
      x2: (d) => d.size.width,
      y2: 0,
    },
    {
      class: "hatch2",
      x1: 0,
      y1: (d) => d.size.height / 2,
      x2: (d) => d.size.width / 2,
      y2: 0,
    },
    {
      class: "hatch3",
      x1: (d) => d.size.width / 2,
      y1: (d) => d.size.height,
      x2: (d) => d.size.width,
      y2: (d) => d.size.height / 2,
    },
  ];

  if (data && data.initiator) {
    hatchLines.forEach(({ class: className, x1, y1, x2, y2 }) => {
      const lines = container.selectAll(`line.${className}`).data(bindingData);
      lines
        .enter()
        .append("line")
        .classed(className, true)
        .merge(lines)
        .attr("x1", x1)
        .attr("y1", y1)
        .attr("x2", x2)
        .attr("y2", y2);
      lines.exit().remove();
    });
  } else {
    hatchLines.forEach(({ class: className }) => {
      container.selectAll(`line.${className}`).remove();
    });
  }
};

export { drawInteraction };
